<div [innerHTML]="(
    'Activate or deactivate this integration to control whether your company is visible on divinea.com .<br>' +
    'This integration can\'t be deleted.'
) | translate" class="center"></div>